import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';
import type { RentalLocation } from '@/api/reservations';

type Variables = { id: string };
type Response = RentalLocation;

export const useLocation = createQuery<Response, Variables, AxiosError>({
  queryKey: ['location'],
  fetcher: ({ id }) => {
    return client.get(`v2/rental_locations/${id}`).then((response) => {
      return response.data.data;
    });
  },
});
